import axios from 'axios';
import type { JsonObject } from '@/app-package';
import type { AppointmentDoc } from '@bb/domain/dist/schemas';

const getAppointmentsForCoop = async (
  pageNumber = 1,
  timeRange?: 'upcoming' | 'past',
) => {
  const { data } = await axios.get<{
    appointments: JsonObject<AppointmentDoc>[];
    count: number;
  }>('/user/coop/appointments', {
    params: { page: pageNumber - 1, timeRange, docType: 'appointment' },
  });

  return data;
};

export { getAppointmentsForCoop };
